import DefaultDialogController from 'utils/notifications/default-dialog-controller';

const mapStateToThis = ({ config }) => {
  const { locales } = config;

  return {
    locales,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', 'appFactory', '$timeout')
class FaqEntryController extends DefaultDialogController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.onLanguageSelect(this.language);
    this.$timeout(() => {
      this.api.initializeForm.run(this.namespace, this.moduleName, this.form, !(this.entry && this.entry.id));
    });
  }

  $onDestroy() {
    this.unsubscribe();
  }

  prepareOptions() {
    return { ...this.api.config.ckeditor, ...this.api.config.faq.ckeditor };
  }

  submit() {
    this.form.$setSubmitted();
    if (this.form.$valid) {
      this.saveEntry.run(this.entry).then(() => this.confirm());
    }
  }

  onLanguageSelect(locale) {
    this.appFactory.model[this.namespace][this.moduleName].language = locale;
  }
}

export default FaqEntryController;



// WEBPACK FOOTER //
// ./src/modules/faq/components/faq-entry-dialog/faq-entry-dialog-controller.js